import { DropdownMenu } from '@octopus-do/octopus-storybook'
import type React from 'react'

import useSpyMode from '@/hooks/useSpyMode'
import { AvatarButton, UserMenuContent } from './components'
import { useUserMenuActions } from './hooks'

export const UserMenu: React.FC = () => {
  const { isSpyMode, updateSpyMode } = useSpyMode()
  const toggleSpyMode = () => updateSpyMode(!isSpyMode)
  const { onClick } = useUserMenuActions(toggleSpyMode)

  return (
    <DropdownMenu.Root
      align="end"
      content={UserMenuContent}
      onClick={onClick}
      isSpyMode={isSpyMode}
    >
      <AvatarButton />
    </DropdownMenu.Root>
  )
}
